<app-basic-cartesian-chart
  class="hide-check"
  [config]="ChartConfig.WhakaaweWaipaRiverNgaruawahia"
></app-basic-cartesian-chart>
<app-basic-cartesian-chart class="hide-check" [config]="ChartConfig.WhakaaweKarapiroStream"></app-basic-cartesian-chart>
<app-basic-cartesian-chart
  class="hide-check"
  [config]="ChartConfig.WhakaaweKMangaharakekeStream"
></app-basic-cartesian-chart>
<app-basic-cartesian-chart
  class="hide-check"
  [config]="ChartConfig.EcoKMangaharakekeStream"
></app-basic-cartesian-chart>
<app-basic-cartesian-chart class="hide-check" [config]="ChartConfig.WaiKWaihouRiver"></app-basic-cartesian-chart>
<app-basic-cartesian-chart class="hide-check" [config]="ChartConfig.EcoKWaihouRiver"></app-basic-cartesian-chart>
